import axios from 'axios';

export default {

    findAllSpecialGroup (itemSectionId, maxResults) {
        return axios.get('/api/special/group/get/', { params: {itemSectionId:itemSectionId, maxResults:maxResults} })
        .then(response => {
            if (response && response.data) return response.data;
        })
        .catch(error => {console.log(error);})
    },

    getSpecialGroupBySeoName (seoname, sectionSeoName) {
        return axios.get('/api/special/group/get/seoname', { params: { seoname:seoname, sectionSeoName:sectionSeoName } })
        .then(response => {
            if (response && response.data) return response.data;
        })
        .catch(error => {console.log(error);})
    },

    getItemSpecialGroup (page, pageSize , specialGroupId, itemSectionId) {
        return axios.get('/api/special/group/get/id', { params: { page: page, pageSize: pageSize , specialGroupId:specialGroupId, itemSectionId:itemSectionId} })
        .then(response => {
            if (response && response.data) return response.data;
        })
        .catch(error => {console.log(error);})
    },
}